import { useMutation } from "@tanstack/react-query";
import { useOrderContext } from "app/providers/OrderProvider";
import { toast } from "react-toastify";
import { api } from "shared/api";
import { getFormattedBumbalRequest } from "shared/utils/date";

export const useCreateSelfAssemblyBumbalDate = () => {
  const { order } = useOrderContext();
  const createBumbalDate = async (selectedDate: Date) => {
    if (!order) return;
    const res = await api().gersCreateBumbalDate(order.id, {
      dateFrom: getFormattedBumbalRequest(selectedDate).dateFrom,
      dateTo: getFormattedBumbalRequest(selectedDate).dateTo,
      type: "shipment",
    });

    return res.data;
  };

  const mutateBumbalDate = useMutation(createBumbalDate, {
    onError: (error) => {
      toast.error(
        "Oh nee, er is een fout opgetreden! Excuus voor het ongemak.",
      );
    },
  });

  const makeBumbalDateSelfAssembly = async () => {
    try {
      const calendarDate = localStorage.getItem("gewoongers_selectedDate");
      if (!calendarDate) return;

      const selectedDate = new Date(calendarDate);
      // Trigger the mutation asynchronously
      await mutateBumbalDate.mutateAsync(selectedDate);
    } catch (error) {}
  };

  // Return an object containing the mutation object and the async function
  return {
    makeBumbalDateSelfAssembly,
    isBumbalDateLoading: mutateBumbalDate.isLoading,
    isBumbalDateError: mutateBumbalDate.isError,
  };
};
